import {Box, Divider, Flex, Text, Image, SimpleGrid} from "@mantine/core";
import {IconLayoutGrid, IconList} from "@tabler/icons-react";
import ProductPlaceholderImage from '../../../../../assets/images/product_placeholder.png';
import {decode} from "html-entities";

const _ProductWithCategory = ({component}) => {
  return (
      <Box
          bg={component?.customize_styles?.general_decoration?.background_color}
          mx={component?.customize_styles?.general_decoration?.margin_x}
          my={component?.customize_styles?.general_decoration?.margin_y}
          px={component?.customize_styles?.general_decoration?.padding_x}
          py={component?.customize_styles?.general_decoration?.padding_y}
          style={{
              boxShadow: `#00000014 ${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px`,
              borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
              border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
          }}
      >
          <Divider my={5} />

          <Flex px={24} align="center" justify="space-between" mt={4} mb={35}>
              <Flex align="center" justify="space-between" gap={8}>
                  <IconLayoutGrid color="#4C6C93" />
                  <IconList />
              </Flex>
              <Text>{component?.items.length} items</Text>
          </Flex>

          <SimpleGrid cols={2}>

              {
                  component?.items?.map((item, index) => (
                      <Box
                          key={index}
                          h={170}
                          pos="relative"
                          mx={component?.customize_styles?.box_decoration?.margin_x}
                          my={component?.customize_styles?.box_decoration?.margin_y}
                          px={component?.customize_styles?.box_decoration?.padding_x}
                          py={component?.customize_styles?.box_decoration?.padding_y}
                          bg={component?.customize_styles?.box_decoration?.background_color}
                          style={{
                              boxShadow: `#00000014 ${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px`,
                              borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                              display: "flex",
                              alignItems: "flex-end",
                              border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                          }}
                      >
                          <Box
                              pos="absolute"
                              top="-20px"
                              w={130}
                              h={100}
                              // ta={component?.customize_styles?.image_decoration?.alignment}
                              ta="center"
                              // bg={component?.customize_styles?.image_decoration?.color}
                              style={{
                                  borderRadius: `${component?.customize_styles?.image_decoration?.radius}px`,
                              }}


                          >
                              <Image
                                  src={item.image_url}
                                  fallbackSrc={ProductPlaceholderImage}
                                  alt={item.name}
                                  radius={component?.customize_styles?.image_decoration?.radius}
                                  style={{ width: " 100%", height: " 100%" }}
                              />
                          </Box>

                          <Box>
                              <Text
                                  lineClamp={1}
                                  translate="yes"
                                  c={component?.customize_styles?.name_text_decoration?.color}
                                  fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                  fz={component?.customize_styles?.name_text_decoration?.font_size}
                                  fs={component?.customize_styles?.name_text_decoration?.font_style}
                              >
                                  {item.name}
                              </Text>
                              <Text
                                  lineClamp={1}
                                  translate="yes"
                                  c={component?.customize_styles?.product_category_text_decoration?.color}
                                  fw={component?.customize_styles?.product_category_text_decoration?.font_weight}
                                  fz={component?.customize_styles?.product_category_text_decoration?.font_size}
                                  // bg={component?.customize_styles?.product_category_text_decoration?.background_color}
                                  td={component?.customize_styles?.product_category_text_decoration?.text_decoration}
                              >
                                  {item.product_categories.toString()}
                              </Text>
                              <Text
                                  c={component?.customize_styles?.product_price_text_decoration?.color}
                                  fw={component?.customize_styles?.product_price_text_decoration?.font_weight}
                                  fz={component?.customize_styles?.product_price_text_decoration?.font_size}
                                  // bg={component?.customize_styles?.product_price_text_decoration?.background_color}
                                  td={component?.customize_styles?.product_price_text_decoration?.text_decoration}
                              >
                                  {decode(item?.currency)} {item?.discount_price ? item.discount_price : item?.price}
                              </Text>
                          </Box>
                      </Box>
                  ))
              }

          </SimpleGrid>

      </Box>
  );
}

export default _ProductWithCategory;